const domains = {
  ctct: {
    name: 'Chúng Ta Cùng Tiến',
    domain: 'https://ctct.gdsc.app',
  },
  fptudsc: {
    name: 'Developer Student Community - FPT University HCMC',
    domain: 'https://url.fptudsc.org',
  },
  gdscuit: {
    name: 'Google Developer Student Club - UIT',
    domain: 'https://uit.gdsc.app',
  },
  gdschcmut: {
    name: 'Google Developer Student Club - HCMUT',
    domain: 'https://hcmut.gdsc.app',
  },
  oispmarketing: {
    name: 'OISP Marketing',
    domain: 'https://bkoisp.info',
  },
  youthunion: {
    name: 'OISP Youth Union',
    domain: 'youthunion.bkoisp',
  },
};
export default domains;
